
export type GetNotificationSettingsParams = {
userId: string;
};
